import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('health-board', 'edit-payment-amount');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'appointments',
    {
      type: 'payload',
      selector: ['appointmentId'],
    },
    'copay',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/edit-payment-req.js